// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a5b36f93","93":"764ae741","201":"f525f663","235":"8b971508","327":"c9c49d20","426":"07dd5d61","481":"2e00becb","488":"8913b627","583":"6b4e140d","596":"bfc86577","977":"3d83d99f"}[chunkId] + ".chunk.js";
};